import React from 'react'

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-primary-100">
      <div className="text-center max-w-md mx-auto p-8">
        <div className="w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-4xl font-bold text-primary-600">404</span>
        </div>
        <h1 className="text-3xl font-bold text-secondary-800 mb-4">頁面不存在</h1>
        <p className="text-secondary-600 mb-8">抱歉，您要找的頁面不存在或已被移除。</p>
        <div className="space-y-4">
          <button
            onClick={() => window.history.back()}
            className="btn-secondary w-full"
          >
            返回上一頁
          </button>
          <button
            onClick={() => window.location.href = '/'}
            className="btn-primary w-full"
          >
            回到首頁
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
